<template>
    <form @submit.prevent="PutInvoicePreferenceData" novalidate>
        <div class="first-para">
            Changes to these preferences will apply to future invoices only.
            If you need your invoices reissued, please contact ssalvi@pmaps.in
        </div>
        <div class="header">
            <h4 style="font-weight: 600;">Basic Details</h4>
            <hr style="height: 2px;">
        </div>
        <div class="basic-details-container">
            <div class="label">
                <h5>Registered Company Name</h5>
                <p style="opacity: 50%;">If specified, this name will appear on your invoice instead of your
                    organization name.</p>
                <input v-model="form.registeredCompanyName" class="input-class" type="text" placeholder="Enter Name"
                    pattern="[A-Za-z\s]+" title="Only letters and spaces are allowed"
                    @input="restrictInput($event, 'lettersAndSpaces')" required>
                <span v-if="errors.registeredCompanyName" class="error">{{ errors.registeredCompanyName }}</span>
            </div>
            <div class="label">
                <h5>Email Address</h5>
                <p style="opacity: 50%;">If specified, this email will appear on your invoice instead of your
                    organization email.</p>
                <vue3-select class="vue3-select" v-model="form.emailAddress" @change="this.findConcernedPerson()"
                    :options="allUserEmails" placeholder="Select preferred email address." required />
            </div>
            <div class="label">
                <h5>Concerned Person Name</h5>
                <p style="opacity: 50%;">If specified, this name will appear on your invoice instead of your
                    organization name.</p>
                <input v-model="form.concernedPersonName" class="input-class" type="text"
                    placeholder="Enter Concerned person name" pattern="[A-Za-z\s]+"
                    title="Only letters and spaces are allowed" @input="restrictInput($event, 'lettersAndSpaces')"
                    disabled>
                <span v-if="errors.concernedPersonName" class="error">{{ errors.concernedPersonName }}</span>
            </div>
            <div class="label">
                <h5>CC emails</h5>
                <p style="opacity: 50%;">If specified, these emails will be CC'd on your invoice emails.</p>
                <div v-for="(email, index) in form.ccEmails" :key="index">
                    <input :value="email.value" class="input-class" type="email" disabled>
                    <button @click="removeCcEmail(index)" type="submit" class="rem-cc">×</button>
                </div>
                <span style="color:blue" class="add-email" data-bs-toggle="modal" data-bs-target="#addCC">+ Add
                    Email</span>
            </div>
        </div>
        <div class="header">
            <h4 style="font-weight: 600;">Address</h4>
            <hr style="height: 2px;">
        </div>
        <div class="basic-details-container">
            <div class="label">
                <h5>Country</h5>
                <vue3-select class="vue3-select" v-model="form.country" :options="countries"
                    @update:modelValue="fetchStates(form.country)" placeholder="Select Country" />
            </div>
            <div class="label">
                <h5>State</h5>
                <vue3-select class="vue3-select" v-model="form.state" :options="states" placeholder="Select State"
                    @update:modelValue="fetchCities(form.state)" />
            </div>
            <div class="label">
                <h5>City</h5>
                <vue3-select class="vue3-select" v-model="form.city" :options="cities" placeholder="Select City" />
            </div>
            <div class="label">
                <h5>Street</h5>
                <input v-model="form.street" class="input-class" type="text" placeholder="Enter Street">
            </div>
            <div class="label">
                <h5>Zip</h5>
                <input v-model="form.zip" class="input-class" type="text" placeholder="Enter ZIP" pattern="[0-9]{5,6}"
                    title="ZIP must be 5 or 6 digits" @input="restrictInput($event, 'digits')" required>
                <span v-if="errors.zip" class="error">{{ errors.zip }}</span>
            </div>
        </div>
        <div class="header" v-if="countryIN">
            <h4 style="font-weight: 600;">Additional Details</h4>
            <hr style="height: 2px;">
        </div>
        <div class="additional-details-container">
            <div class="label" v-if="countryIN">
                <h5>GST Number</h5>
                <p style="opacity: 50%;">If specified, this GST number will appear on your invoice.</p>
                <input v-model="form.gstNumber" class="add-input-class" type="text" placeholder="Enter GST number">
            </div>
            <div class="label" v-if="countryIN">
                <h5>Place of Supply</h5>
                <p style="opacity: 50%;">If specified, this place of supply will appear on your invoice.</p>
                <vue3-select class="add-vue3-select" v-model="form.placeOfSupply" :options="placesOfSupply"
                    placeholder="Select an option" />
            </div>
            <button type="submit" class="save-btn" :disabled="!hasChanges">Save</button>
        </div>
        <!-- Modal for adding email -->
        <div class="modal fade" id="addCC" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable model-sm">
                <div class="modal-content border-radius-kj-20">
                    <div class="modal-header token-model-header-color">
                        <h5 class="modal-title text-centerm-auto" id="IncreaseTokenModalLabel">
                            <span class="font-size-20-kj"> Add Email</span>
                            <p class="Active-model-p-kj">
                                Enter the email address you would like to add to CC.
                            </p>
                        </h5>

                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="btn-close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group my-4">
                            <input class="input-class" v-model="newEmail" type="email" placeholder="Enter email"
                                @keyup.enter="addCcEmail">
                            <button @click="addCcEmail" class="add-cc">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import "vue3-select/dist/vue3-select.css";
import Vue3Select from "vue3-select";
import { mapState, mapActions } from "vuex";
import { toast } from "vue3-toastify";

export default {
    name: "PreferencesContent",
    components: {
        Vue3Select,
    },
    data() {
        return {
            allUsers: [],
            allUserEmails: [],
            countryIN: false,
            billingPreferenceData: null,
            form: {
                registeredCompanyName: '',
                emailAddress: '',
                concernedPersonName: '',
                toEmails: [],
                ccEmails: [],
                country: '',
                state: '',
                city: '',
                street: '',
                zip: '',
                gstNumber: '',
                placeOfSupply: ''
            },
            originalForm: {},
            countries: [],
            states: [],
            cities: [],
            placesOfSupply: [],
            newEmail: '',
            preferenceId: 0,
            errors: {
                registeredCompanyName: '',
                emailAddress: '',
                concernedPersonName: '',
                zip: ''
            }
        }
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
        hasChanges() {
            return JSON.stringify(this.form) !== JSON.stringify(this.originalForm);
        }
    },
    methods: {
        ...mapActions(['GetBillingPreference', 'putInvoicePreference', 'getlocation', 'getstatelocation',
            'getcitylocation', 'GetAllUsers',]),
        addCcEmail() {
            if (this.form.ccEmails.some(emailObj => emailObj.value === this.newEmail)) {
                toast.error("Email already added.");
            }
            else if (this.newEmail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.newEmail)) {
                this.form.ccEmails.push({ value: this.newEmail });
                this.newEmail = '';
            } else {
                toast.error("Invalid email.");
            }
        },
        async GetBillingPreferenceData() {
            try {
                const preferdata = await this.GetBillingPreference({
                    clientId: this.user.clientId
                });
                this.billingPreferenceData = preferdata.object.data[0];
                if (this.billingPreferenceData) this.preferenceId = this.billingPreferenceData.preferenceId
                this.populateForm();
            } catch (error) {
                console.error("Error fetching billing preferences:", error);
            }
        },
        populateForm() {
            if (this.billingPreferenceData) {
                this.form.registeredCompanyName = this.billingPreferenceData.companyName || '';
                this.form.emailAddress = this.billingPreferenceData.email || '';
                this.form.concernedPersonName = this.billingPreferenceData.attentionName || '';
                this.form.toEmails = this.billingPreferenceData.toEmails.map(email => ({ value: email })) || [];
                this.form.ccEmails = this.billingPreferenceData.ccEmails.map(email => ({ value: email })) || [];
                this.form.country = this.billingPreferenceData.country || '';
                this.form.state = this.billingPreferenceData.state || '';
                this.form.city = this.billingPreferenceData.city || '';
                this.form.street = this.billingPreferenceData.street || '';
                this.form.zip = this.billingPreferenceData.zip || '';
                this.form.gstNumber = this.billingPreferenceData.gstNo || '';
                this.form.placeOfSupply = this.billingPreferenceData.placeOfSupply || '';
                this.originalForm = JSON.parse(JSON.stringify(this.form));
            }
        },
        async PutInvoicePreferenceData() {
            if (this.validateForm()) {
                try {
                    const model = {
                        preferenceId: this.preferenceId,
                        clientId: `${this.user.clientId}`,
                        clientName: this.user.firstName + " " + this.user.lastName,
                        email: this.form.emailAddress,
                        companyName: this.form.registeredCompanyName,
                        attentionName: this.form.concernedPersonName,
                        gstNo: this.user.countryCode === "IN" ? this.form.gstNumber : "",
                        street: this.form.street,
                        city: this.form.city.label,
                        country: this.form.country.label,
                        state: this.form.state.label,
                        zip: `${this.form.zip}`,
                        toEmails: [this.form.emailAddress],
                        ccEmails: this.form.ccEmails.map(x => x.value),
                        placeOfSupply: this.form.placeOfSupply.value
                    };
                    const res = await this.putInvoicePreference(model);
                    console.log("Save successful:", res);
                    this.originalForm = JSON.parse(JSON.stringify(this.form));
                } catch (error) {
                    console.error("Error saving preferences:", error);
                }
            }
        },
        removeCcEmail(index) {
            this.form.ccEmails.splice(index, 1);
        },
        async fetchDropdownData() {
            try {
                const response = await this.getlocation();
                this.countries = response.object.data.map(country => ({
                    label: country.name,
                    value: country.iso2
                }));
            } catch (error) {
                console.error("Error fetching dropdown data:", error);
            }
        },
        async fetchStates(iso2) {
            try {
                const response = await this.getstatelocation({ countryCode: iso2.value });
                this.states = response.object.data.map(state => ({
                    label: state.name,
                    value: state.iso2,
                    countryCode: state.country_code
                }));
            } catch (error) {
                console.error("Error fetching states:", error);
                this.states = [];
            }
        },
        async fetchCities(state) {
            try {
                const response = await this.getcitylocation({
                    stateCode: state.value,
                    countryCode: state.countryCode
                });
                this.cities = response.object.data.map(city => ({
                    label: city.name,
                    value: city.country_code
                }));
            } catch (error) {
                console.error("Error fetching states:", error);
                this.cities = [];
            }
        },
        restrictInput(event, type) {
            const input = event.target;
            let value = input.value;
            if (type === 'lettersAndSpaces') {
                value = value.replace(/[^A-Za-z\s]/g, '');
            } else if (type === 'digits') {
                value = value.replace(/[^0-9]/g, '');
            }
            input.value = value;
            this.form[input.name] = value;
        },
        validateForm() {
            this.clearErrors();
            let isValid = true;
            if (this.form.concernedPersonName === '') {
                this.errors.concernedPersonName = "Cannot be empty";
                isValid = false;
            }
            else if (!this.form.concernedPersonName.match(/^[A-Za-z\s]+$/)) {
                this.errors.concernedPersonName = "Only letters and spaces are allowed";
                isValid = false;
            }
            if (this.form.registeredCompanyName === '') {
                this.errors.registeredCompanyName = "Cannot be empty";
                isValid = false;
            } else if (!this.form.registeredCompanyName.match(/^[A-Za-z\s]+$/)) {
                this.errors.registeredCompanyName = "Only letters and spaces are allowed";
                isValid = false;
            }
            if (this.form.emailAddress == null) {
                toast.error("Please select an Email Address.")
                isValid = false;
            }

            if (this.form.zip && !this.form.zip.match(/^[0-9]{5,6}$/)) {
                this.errors.zip = "ZIP must be 5 or 6 digits";
                isValid = false;
            }
            return isValid;
        },
        clearErrors() {
            this.errors = {
                registeredCompanyName: '',
                emailAddress: '',
                concernedPersonName: '',
                zip: ''
            };
        },
        findConcernedPerson() {
            const selectedUser = this.allUsers.find(user => user.email === this.form.emailAddress);
            this.form.concernedPersonName = selectedUser.name;
        },
        async getAllUserDetails() {

            var model = {
                status: 4,
                clientId: this.user.clientId,
                limit: 999,
                page: 1,

            };

            var users = await this.GetAllUsers(model);
            this.allUsers = users.object.data.users;
            this.allUserEmails = this.allUsers.map(user => user.email)
        },
    },
    mounted() {
        this.GetBillingPreferenceData();
        this.fetchDropdownData();
        this.getAllUserDetails();
        // console.log("what is this",this.form.country)
        // if (this.form.country) {
        //     this.fetchStates(this.form.country)
        //     console.log("mounted states",this.states)
        // }
    },
    async created() {
        let country = this.user.countryCode;
        if (country === 'IN') {
            this.countryIN = true;
            try {
                const response = await this.getstatelocation({ countryCode: 'IN' });
                this.placesOfSupply = response.object.data.map(state => ({
                    label: state.name,
                    value: state.iso2,
                    countryCode: state.country_code
                }));
            } catch (error) {
                console.error("Error fetching states:", error);
                this.placesOfSupply = [];
            }
        }
    }
}
</script>

<style scoped>
.rem-cc {
    color: red;
    margin-left: 0.5rem;
    background: transparent;
    border: none
}

.close-btn {
    background: transparent;
    color: blue;
    width: 6rem;
    border-radius: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid blue;
    height: 38px;
    margin-left: 17rem;
    margin-top: 2rem;
    cursor: pointer;
}

.add-email {
    margin-top: 1rem;
}

.add-email:hover {
    cursor: pointer;
}

.first-para {
    margin-left: 2rem;
    margin-top: 2.5rem;
    opacity: 50%;
}

.header {
    margin-left: 2rem;
    margin-top: 2.5rem;
}

.basic-details-container {
    margin-left: 2rem;
}

.additional-details-container {
    margin-left: 2rem;
    width: 53.5%;
}

.input-class {
    border: 2px solid;
    border-radius: 5px;
    border-color: rgba(128, 128, 128, 0.5);
    padding: 5px 7px;
    width: 55%;
    margin-top: 0.8rem;
}

.add-input-class {
    border: 2px solid;
    border-radius: 5px;
    border-color: rgba(128, 128, 128, 0.5);
    padding: 5px 7px;
    width: 100%;
    margin-top: 0.8rem;
}

.label {
    margin-top: 1.5rem;
}

.vue3-select {
    border: 1px solid;
    border-radius: 5px;
    border-color: rgba(128, 128, 128, 0.5);
    width: 55%;
    margin-top: 0.8rem;
    background-color: white;
}

.add-vue3-select {
    border: 1px solid;
    border-radius: 5px;
    border-color: rgba(128, 128, 128, 0.5);
    width: 100%;
    margin-top: 0.8rem;
    background-color: white;
}

.save-btn {
    background: #4F46E5;
    color: white;
    width: 8rem;
    border-radius: 4px;
    border: none;
    padding: 7px 0px;
    margin-top: 2rem;
    font-size: large;
    float: inline-end;
}

.add-cc {
    background: #4F46E5;
    color: white;
    width: 6rem;
    border-radius: 4px;
    border: none;
    padding: 7px 0px;
    margin-top: 1.8rem;
    font-size: medium;
    margin-left: 1rem;
}

.save-btn:disabled {
    background: #cccccc;
    cursor: not-allowed;
}
</style>